import {getUserColor} from '@dms/shared';

/**
 * Resolves the owner-identity tint (#RRGGBB) for a kanban card from the owner's position
 * in the watched-users list. Cards stay untinted when only one user is watched, when the
 * owner is the first watched user (the current user — "no stripes = mine"), or when the
 * owner is not watched at all.
 */
export function getCardOwnerColor(selectedUsers: {id: string}[], ownerId: string): string | null {
  const ownerIndex = selectedUsers.findIndex((user) => user.id === ownerId);

  return selectedUsers.length > 1 && ownerIndex > 0 ? getUserColor(ownerIndex) : null;
}
